import { Component, ViewChild } from '@angular/core';
import { TaxCategorySlabFormComponent } from '../tax-category-slab-form/tax-category-slab-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { Subject } from 'rxjs';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-tax-category-slab',
  standalone: true,
  imports: [CommonModule, DataTablesModule],
  templateUrl: './tax-category-slab.component.html',
  styleUrl: './tax-category-slab.component.scss'
})
export class TaxCategorySlabComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  HolidayData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };  
  }

  ngOnInit(): void {
    this.TaxSlabMasterSelectLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  TaxSlabMasterSelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxSlabMasterSelectLoad({ SelectType: 'S', ESS_TaxSlabMasterID: 0, ESS_TaxCategoryMasterID: 0, FinancialYearFrom: '', FinancialYearTo: '' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTaxCategorySlab(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(TaxCategorySlabFormComponent,{
        size: 'lg',
        backdrop: 'static',
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if(result){
            this.TaxSlabMasterSelectLoad();
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Tax Category Slab Master')
    }
  }
}
